// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b15ee467","455":"2b38a511","977":"b10269b4"}[chunkId] + ".chunk.js";
};